!function() {
    "use strict";
    let o = {
        normal: "",
        hover: "-hvr",
        focus: "-focus"
    }
      , l = o => Object.entries(o).filter( ([,o]) => void 0 !== o).map( ([o,l]) => `${o}: ${l};`).join(" ")
      , i = o => Object.fromEntries(Object.entries(o).map( ([o,l]) => [`--${o}`, l]))
      , d = o => {
        if (o)
            return o && "string" == typeof o && ((null == o ? void 0 : o.startsWith("#")) || (null == o ? void 0 : o.startsWith("rgb")) || (null == o ? void 0 : o.startsWith("RGB")) || (null == o ? void 0 : o.startsWith("hsl")) || (null == o ? void 0 : o.startsWith("transparent")) || (null == o ? void 0 : o.startsWith("linear-gradient"))) ? o : `var(--g-c-${o}, ${o})`
    }
      , e = (o, l) => {
        if (!l)
            return {};
        let i = {
            normal: "",
            hover: "-hvr",
            focus: "-focus"
        };
        return Object.fromEntries(Object.entries(l).map( ([l,e]) => "active" === l ? [] : [`-${null == i ? void 0 : i[l]}-${o}`, d(e)]))
    }
      , v = (o, l) => {
        var i, d, e, v, n, t, r, u, a;
        return l ? {
            [`--${o}`]: null == l ? void 0 : null === (i = l.desktop) || void 0 === i ? void 0 : i.normal,
            [`--hvr-${o}`]: null == l ? void 0 : null === (d = l.desktop) || void 0 === d ? void 0 : d.hover,
            [`--focus-${o}`]: null == l ? void 0 : null === (e = l.desktop) || void 0 === e ? void 0 : e.focus,
            [`--${o}-tablet`]: null == l ? void 0 : null === (v = l.tablet) || void 0 === v ? void 0 : v.normal,
            [`--hvr-${o}-tablet`]: null == l ? void 0 : null === (n = l.tablet) || void 0 === n ? void 0 : n.hover,
            [`--focus-${o}-tablet`]: null == l ? void 0 : null === (t = l.tablet) || void 0 === t ? void 0 : t.focus,
            [`--${o}-mobile`]: null == l ? void 0 : null === (r = l.mobile) || void 0 === r ? void 0 : r.normal,
            [`--hvr-${o}-mobile`]: null == l ? void 0 : null === (u = l.mobile) || void 0 === u ? void 0 : u.hover,
            [`--focus-${o}-mobile`]: null == l ? void 0 : null === (a = l.mobile) || void 0 === a ? void 0 : a.focus
        } : {}
    }
      , n = o => {
        var l, i, d, e, n, t, r, u, s, b, c, h, m, f, p, g, w, k, $, y, E, T, O;
        if (!o)
            return;
        if ("desktop"in o || "tablet"in o || "mobile"in o) {
            let l = {
                desktop: {
                    normal: null === (t = o.desktop) || void 0 === t ? void 0 : null === (n = t.normal) || void 0 === n ? void 0 : n.border,
                    hover: null === (u = o.desktop) || void 0 === u ? void 0 : null === (r = u.hover) || void 0 === r ? void 0 : r.border,
                    focus: null === (b = o.desktop) || void 0 === b ? void 0 : null === (s = b.focus) || void 0 === s ? void 0 : s.border
                },
                tablet: {
                    normal: null === (h = o.tablet) || void 0 === h ? void 0 : null === (c = h.normal) || void 0 === c ? void 0 : c.border,
                    hover: null === (f = o.tablet) || void 0 === f ? void 0 : null === (m = f.hover) || void 0 === m ? void 0 : m.border,
                    focus: null === (g = o.tablet) || void 0 === g ? void 0 : null === (p = g.focus) || void 0 === p ? void 0 : p.border
                },
                mobile: {
                    normal: null === (k = o.mobile) || void 0 === k ? void 0 : null === (w = k.normal) || void 0 === w ? void 0 : w.border,
                    hover: null === (y = o.mobile) || void 0 === y ? void 0 : null === ($ = y.hover) || void 0 === $ ? void 0 : $.border,
                    focus: null === (T = o.mobile) || void 0 === T ? void 0 : null === (E = T.focus) || void 0 === E ? void 0 : E.border
                }
            };
            return v("bs", l)
        }
        let j = {
            normal: null == o ? void 0 : null === (l = o.normal) || void 0 === l ? void 0 : l.border,
            hover: null !== (O = null == o ? void 0 : null === (i = o.hover) || void 0 === i ? void 0 : i.border) && void 0 !== O ? O : null == o ? void 0 : null === (d = o.normal) || void 0 === d ? void 0 : d.border,
            focus: null == o ? void 0 : null === (e = o.focus) || void 0 === e ? void 0 : e.border
        };
        return a("bs", j)
    }
      , t = o => {
        var l, i, d, e, n, t, r, u, s, b, c, h, m, f, p, g, w, k, $, y, E, T, O, j, A, C, L, S, I, W, B, R;
        if (!o)
            return;
        if ("desktop"in o || "tablet"in o || "mobile"in o) {
            let l = {
                desktop: {
                    normal: null === (t = o.desktop) || void 0 === t ? void 0 : null === (n = t.normal) || void 0 === n ? void 0 : n.width,
                    hover: null !== (I = null === (u = o.desktop) || void 0 === u ? void 0 : null === (r = u.hover) || void 0 === r ? void 0 : r.width) && void 0 !== I ? I : null === (b = o.desktop) || void 0 === b ? void 0 : null === (s = b.normal) || void 0 === s ? void 0 : s.width,
                    focus: null === (h = o.desktop) || void 0 === h ? void 0 : null === (c = h.focus) || void 0 === c ? void 0 : c.width
                },
                tablet: {
                    normal: null === (f = o.tablet) || void 0 === f ? void 0 : null === (m = f.normal) || void 0 === m ? void 0 : m.width,
                    hover: null !== (W = null === (g = o.tablet) || void 0 === g ? void 0 : null === (p = g.hover) || void 0 === p ? void 0 : p.width) && void 0 !== W ? W : null === (k = o.tablet) || void 0 === k ? void 0 : null === (w = k.normal) || void 0 === w ? void 0 : w.width,
                    focus: null === (y = o.tablet) || void 0 === y ? void 0 : null === ($ = y.focus) || void 0 === $ ? void 0 : $.width
                },
                mobile: {
                    normal: null === (T = o.mobile) || void 0 === T ? void 0 : null === (E = T.normal) || void 0 === E ? void 0 : E.width,
                    hover: null !== (B = null === (j = o.mobile) || void 0 === j ? void 0 : null === (O = j.hover) || void 0 === O ? void 0 : O.width) && void 0 !== B ? B : null === (C = o.mobile) || void 0 === C ? void 0 : null === (A = C.normal) || void 0 === A ? void 0 : A.width,
                    focus: null === (S = o.mobile) || void 0 === S ? void 0 : null === (L = S.focus) || void 0 === L ? void 0 : L.width
                }
            };
            return v("bw", l)
        }
        let N = {
            normal: null == o ? void 0 : null === (l = o.normal) || void 0 === l ? void 0 : l.width,
            hover: null !== (R = null == o ? void 0 : null === (i = o.hover) || void 0 === i ? void 0 : i.width) && void 0 !== R ? R : null == o ? void 0 : null === (d = o.normal) || void 0 === d ? void 0 : d.width,
            focus: null == o ? void 0 : null === (e = o.focus) || void 0 === e ? void 0 : e.width
        };
        return a("bw", N)
    }
      , r = o => {
        var l, i, d, v, n, t, r, a, s, b, c, h, m, f, p, g, w, k, $, y, E, T, O, j, A, C, L, S, I, W, B, R;
        if (!o)
            return;
        if ("desktop"in o || "tablet"in o || "mobile"in o) {
            let l = {
                desktop: {
                    normal: null === (t = o.desktop) || void 0 === t ? void 0 : null === (n = t.normal) || void 0 === n ? void 0 : n.color,
                    hover: null !== (I = null === (a = o.desktop) || void 0 === a ? void 0 : null === (r = a.hover) || void 0 === r ? void 0 : r.color) && void 0 !== I ? I : null === (b = o.desktop) || void 0 === b ? void 0 : null === (s = b.normal) || void 0 === s ? void 0 : s.color,
                    focus: null === (h = o.desktop) || void 0 === h ? void 0 : null === (c = h.focus) || void 0 === c ? void 0 : c.color
                },
                tablet: {
                    normal: null === (f = o.tablet) || void 0 === f ? void 0 : null === (m = f.normal) || void 0 === m ? void 0 : m.color,
                    hover: null !== (W = null === (g = o.tablet) || void 0 === g ? void 0 : null === (p = g.hover) || void 0 === p ? void 0 : p.color) && void 0 !== W ? W : null === (k = o.tablet) || void 0 === k ? void 0 : null === (w = k.normal) || void 0 === w ? void 0 : w.color,
                    focus: null === (y = o.tablet) || void 0 === y ? void 0 : null === ($ = y.focus) || void 0 === $ ? void 0 : $.color
                },
                mobile: {
                    normal: null === (T = o.mobile) || void 0 === T ? void 0 : null === (E = T.normal) || void 0 === E ? void 0 : E.color,
                    hover: null !== (B = null === (j = o.mobile) || void 0 === j ? void 0 : null === (O = j.hover) || void 0 === O ? void 0 : O.color) && void 0 !== B ? B : null === (C = o.mobile) || void 0 === C ? void 0 : null === (A = C.normal) || void 0 === A ? void 0 : A.color,
                    focus: null === (S = o.mobile) || void 0 === S ? void 0 : null === (L = S.focus) || void 0 === L ? void 0 : L.color
                }
            };
            return u("bc", l)
        }
        let N = {
            normal: null == o ? void 0 : null === (l = o.normal) || void 0 === l ? void 0 : l.color,
            hover: null !== (R = null == o ? void 0 : null === (i = o.hover) || void 0 === i ? void 0 : i.color) && void 0 !== R ? R : null == o ? void 0 : null === (d = o.normal) || void 0 === d ? void 0 : d.color,
            focus: null == o ? void 0 : null === (v = o.focus) || void 0 === v ? void 0 : v.color
        };
        return e("bc", N)
    }
      , u = (l, i) => i ? Object.entries(i).map( ([i,e]) => "desktop" === i ? Object.fromEntries(Object.entries(e).map( ([i,e]) => "active" === i ? [] : [`-${o[i]}-${l}`, d(e)])) : Object.fromEntries(Object.entries(e).map( ([e,v]) => "active" === e ? [] : [`-${o[e]}-${l}-${i}`, d(v)]))).reduce( (o, l) => ({
        ...o,
        ...l
    }), {}) : {}
      , a = (o, l) => l ? {
        [`--${o}`]: null == l ? void 0 : l.normal,
        [`--hvr-${o}`]: null == l ? void 0 : l.hover,
        [`--focus-${o}`]: null == l ? void 0 : l.focus
    } : {}
      , s = (o, l) => ({
        [`--${o}`]: null == l ? void 0 : l.desktop,
        [`--${o}-tablet`]: null == l ? void 0 : l.tablet,
        [`--${o}-mobile`]: null == l ? void 0 : l.mobile
    })
      , b = (o, l, i) => {
        let d = o.getAttribute("gp-data-interaction")
          , e = JSON.parse(d || "{}");
        o.setAttribute("gp-data-interaction", JSON.stringify({
            ...e,
            [l]: i
        }))
    }
    ;
    function c(o, l, i) {
        return l in o ? Object.defineProperty(o, l, {
            value: i,
            enumerable: !0,
            configurable: !0,
            writable: !0
        }) : o[l] = i,
        o
    }
    let h = () => {
        window.removeEventListener("gp-global-loaded", h),
        customElements.get("gp-tab") || customElements.define("gp-tab", class extends GP.Component {
            getValueByDevice(o, l) {
                return (null == o ? void 0 : o[l]) === void 0 ? (null == o ? void 0 : o.desktop) === void 0 ? null == o ? void 0 : o.tablet : null == o ? void 0 : o.desktop : null == o ? void 0 : o[l]
            }
            dispatchEventActiveTab(o) {
                var l;
                (null === (l = window) || void 0 === l ? void 0 : l.interactionLoaded) || this.dispatchEvent(new CustomEvent("gp:tab-active",{
                    detail: o
                })),
                this.interactionListenerLoaded( () => {
                    this.trigger && (this.trigger({
                        event: "gp:rollback:tab-active"
                    }),
                    this.trigger({
                        event: "gp:tab-active",
                        data: o
                    }))
                }
                )
            }
            changeOpenTabInteraction(o, l) {
                let {data: i, isRollback: d, element: e, key: v} = o || {};
                if (void 0 === i && d)
                    return;
                let n = Number(i);
                if (d) {
                    this.tabClickRef(n);
                    return
                }
                b(e, v, String(l)),
                this.tabClickRef(n)
            }
            constructor() {
                var o, v, u, a, b, h, m, f, p, g, w, k, $, y, E, T, O, j, A, C, L, S, I;
                super(),
                c(this, "previousActiveId", 0),
                c(this, "tabClickRef", void 0),
                c(this, "interactionListenerLoaded", o => {
                    if (window.interactionLoaded) {
                        o();
                        return
                    }
                    window.addEventListener("gp:flow-actions-loaded", () => {
                        o()
                    }
                    )
                }
                );
                let W = window.screenSize.getDeviceName()
                  , B = this.getState("setting")
                  , R = null === (o = this.getState("builderProps")) || void 0 === o ? void 0 : o.uid
                  , N = this.querySelectorAll(`.gp-navs-tab[key="${R}"]`)
                  , D = this.querySelectorAll(`.gp-tab-item-container[key="${R}"] > .gp-tab-item`)
                  , K = 0 < parseInt(B.activeKey) && parseInt(B.activeKey) < B.childItem.length ? parseInt(null == B ? void 0 : B.activeKey) : 0;
                this.previousActiveId = K,
                this.dispatchEventActiveTab(K);
                let P = i({
                    c: d(null !== (j = null == B ? void 0 : null === (v = B.labelColor) || void 0 === v ? void 0 : v.active) && void 0 !== j ? j : null == B ? void 0 : null === (u = B.labelColor) || void 0 === u ? void 0 : u.normal),
                    bgc: d(null !== (A = null == B ? void 0 : null === (a = B.labelBgColor) || void 0 === a ? void 0 : a.active) && void 0 !== A ? A : null == B ? void 0 : null === (b = B.labelBgColor) || void 0 === b ? void 0 : b.normal),
                    bs: null !== (C = null == B ? void 0 : null === (m = B.borderTab) || void 0 === m ? void 0 : null === (h = m.active) || void 0 === h ? void 0 : h.border) && void 0 !== C ? C : null == B ? void 0 : null === (p = B.borderTab) || void 0 === p ? void 0 : null === (f = p.normal) || void 0 === f ? void 0 : f.border,
                    bw: null !== (L = null == B ? void 0 : null === (w = B.borderTab) || void 0 === w ? void 0 : null === (g = w.active) || void 0 === g ? void 0 : g.width) && void 0 !== L ? L : null == B ? void 0 : null === ($ = B.borderTab) || void 0 === $ ? void 0 : null === (k = $.normal) || void 0 === k ? void 0 : k.width,
                    bc: d(null !== (S = null == B ? void 0 : null === (E = B.borderTab) || void 0 === E ? void 0 : null === (y = E.active) || void 0 === y ? void 0 : y.color) && void 0 !== S ? S : null == B ? void 0 : null === (O = B.borderTab) || void 0 === O ? void 0 : null === (T = O.normal) || void 0 === T ? void 0 : T.color)
                })
                  , q = {
                    ...e("c", null == B ? void 0 : B.labelColor),
                    ...e("bgc", null == B ? void 0 : B.labelBgColor),
                    ...n(null == B ? void 0 : B.borderTab),
                    ...t(null == B ? void 0 : B.borderTab),
                    ...r(null == B ? void 0 : B.borderTab)
                }
                  , G = this.getValueByDevice(null == B ? void 0 : B.position, W)
                  , J = {
                    ...s("jc", null == B ? void 0 : B.labelAlign),
                    ...s("w", "top" !== G && B.position ? null == B ? void 0 : B.labelWidth : null == B ? void 0 : B.panelWidth)
                };
                function V(o, i) {
                    let d = N[o]
                      , e = l(J)
                      , v = (null == B ? void 0 : B.enableActiveEffect) === !0 || (null == B ? void 0 : B.enableActiveEffect) === void 0
                      , n = l(i && v ? P : q);
                    if (d.setAttribute("style", e.concat(n)),
                    D[o]) {
                        let l = D[o];
                        l.style.visibility = i ? "visible" : "hidden",
                        l.style.position = i ? "relative" : "absolute",
                        l.style.height = i ? "auto" : "0",
                        l.style.overflow = i ? "unset" : "hidden"
                    }
                }
                function x(o) {
                    V(K, !1),
                    K = o,
                    V(o, !0)
                }
                if (this.tabClickRef = x,
                this.onTrigger && this.onTrigger({
                    event: "gp:change-open-tab"
                }, o => {
                    let {isRollback: l, uniqueStorageKey: i, data: d} = o || {};
                    this.changeOpenTabInteraction({
                        isRollback: l,
                        data: d,
                        key: i,
                        element: this
                    }, K)
                }
                ),
                N) {
                    let o = N.length;
                    for (let l = 0; l < o; l++) {
                        let o = l === K;
                        V(l, o),
                        null === (I = N[l]) || void 0 === I || I.addEventListener("click", () => {
                            x(l),
                            this.dispatchEventActiveTab(l)
                        }
                        )
                    }
                }
            }
        }
        )
    }
    ;
    "completed" === window.gpReadyState ? h() : window.addEventListener("gp-global-loaded", h)
}();
